/* eslint-disable @typescript-eslint/indent */
import React, { useContext, useEffect, useState } from 'react';
import HomePage from '@/api/homePage';
import { IError } from '@/interfaces/common';
import { ICategory } from '@pwskills/rachnaui/components/Navbar/Navbar.types';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { COURSE_PURCHASE_TYPE } from '@/utils/common/common.constants';
import BaseLayout from '../common/BaseLayout';
import NavHeaderSection from '../common/CourseDescriptionPage/NavHeaderSection';
import CourseCurriculum from '../common/CourseDescriptionPage/CourseCurriculum';
import ProjectSection from '../common/CourseDescriptionPage/ProjectSection';
import GetConnected from '../common/GetConnected';
import Faq from '../common/CourseDescriptionPage/Faq';
import HeroSection from './HeroSection';
import ProgramOutcomes from '../common/CourseDescriptionPage/ProgramOutcomes';
import OfferingsSection from './OfferingsSection';
import AlumniSection from './AlumniSection';
import PlansSection from '../common/CourseDescriptionPage/PlansSection';
import StillConfusedStrip from '../common/CourseDescriptionPage/StillConfusedStrip';
import GetCertified from '../common/CourseDescriptionPage/GetCertified';
import SEOSection from '../common/CourseDescriptionPage/SEOSection';
import AlumniTestimonialTileType from '../common/CourseDescriptionPage/AlumniTestimonialTileType';
import AlumniTestimonialTextType from '../common/CourseDescriptionPage/AlumniTestimonialTextType';
import { LeadCaptureEnquiryType, ModalType } from '../../interfaces/leadCapture.enum';
import OurMentors from '../HomePageRevamp/Mentors';
import LeadFormModal2 from '../common/LeadForm/LeadFormModal2';
import AboutProgram from '../CourseDescriptionPageProfessional/AboutProgram';

const CourseDescriptionPageAmateur = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const courseMetaDetails = courseDetails?.courseMetaDetails;
  const [categoryData, setCategoryData] = useState<ICategory[]>([]);
  const fetchCompanyAndFaqsDetails = async () => {
    try {
      const catchResponse = await HomePage.getCompanyAndFaqs();

      if (catchResponse) {
        const categoryDetails = catchResponse?.data?.categories;
        setCategoryData(categoryDetails);
      }
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
    }
  };
  useEffect(() => {
    fetchCompanyAndFaqsDetails();
  }, []);
  return (
    <main className="bg-white">
      <div className="relative">
        <BaseLayout category={categoryData} pageName="course_description">
          <NavHeaderSection darkTheme />
          <HeroSection />
          <AboutProgram isArmature />
          {courseMetaDetails?.enableAboutCourse && <ProgramOutcomes />}
          <OfferingsSection />
          {/* <OnboardingProcess /> */}
          {courseMetaDetails?.enableCurriculum && <CourseCurriculum />}
          {courseMetaDetails?.enableProjectGallery && <ProjectSection />}
          {/* {courseMetaDetails?.enableCourseInstructor && <OurMentors />} */}
          {courseMetaDetails?.enableCourseInstructor && <OurMentors />}
          {courseMetaDetails?.enableAlumniCompany && <AlumniSection />}
          {/*  show plan section only when its enable and length is greater than 0 */}
          {courseDetails?.coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN &&
            courseMetaDetails?.coursePlansDetails &&
            courseMetaDetails?.coursePlansDetails?.length > 0 && <PlansSection />}

          {/* show still confused strip fro plan type course only */}
          {courseDetails?.coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN &&
            courseMetaDetails?.coursePlansDetails &&
            courseMetaDetails?.coursePlansDetails?.length > 0 && <StillConfusedStrip />}

          {courseMetaDetails?.enableCertificate && <GetCertified />}
          {courseMetaDetails?.enableAlumniTestimonials &&
            courseMetaDetails?.testimonials &&
            courseMetaDetails?.testimonials.length > 0 && (
              <>
                {courseMetaDetails?.alumniTestimonial?.type === 'TILE' && (
                  <AlumniTestimonialTileType />
                )}
                {courseMetaDetails?.alumniTestimonial?.type === 'TEXT' && (
                  <AlumniTestimonialTextType />
                )}
              </>
            )}
          {courseMetaDetails?.counsellingStripOne && (
            <GetConnected
              isConfused={false}
              title="Talk to Our Counsellor"
              subTitle="Get Expert Advice our Counsellor will reach within"
              buttonText="Get Connected"
              img="/images/courseDescription/get-in-touch.svg"
              msgLineOne="We Got Your Response."
              msgLineTwo="Our Counsellor will reach out soon"
              type="ConnectWithCounsellor"
              enquiryType={LeadCaptureEnquiryType.GET_IN_TOUCH}
              enquiryTypeNPF="Get in Touch"
              pageName="course_description"
            />
          )}
          {courseMetaDetails?.enableSEO && <SEOSection />}
          {courseMetaDetails?.counsellingStripTwo && (
            <GetConnected
              isConfused
              title="Still Confused?"
              subTitle="Get Connected to our experts and know what's best for you."
              buttonText="Get Connected"
              img="/images/courseDescription/get-in-touch.svg"
              msgLineOne="We Got Your Response."
              msgLineTwo="Our Counsellor will reach out soon"
              type="ConnectWithCounsellor"
              enquiryType={LeadCaptureEnquiryType.GET_IN_TOUCH}
              enquiryTypeNPF="Get in Touch"
              pageName="course_description"
            />
          )}
          <Faq />
          <LeadFormModal2
            buttonText="Next"
            enquiryTypeNPF={LeadCaptureEnquiryType.COURSE_DESCRIPTION_LEADFORM}
            modalType={ModalType.LEAD_FORM}
            pageName="course_description"
          />
        </BaseLayout>
      </div>
    </main>
  );
};

export default CourseDescriptionPageAmateur;
